export default __webpack_public_path__ + "732458c6a59f4b3f7f7a104699dbeb61.png";